import { FormattedMessage } from 'react-intl';
import { getPromotionalFeatures } from '../helpers';
import style from '../migration-plan-modal.module.less';

/**
 * @param {object} props
 * @param {string} props.billingPlanId
 * @returns {JSX.Element}
 */
export const PromotionalFeatureList = ({ billingPlanId }) => {
  const sellingPoints = getPromotionalFeatures(billingPlanId);
  return (
    <ul className={style['feature-list']}>
      <FormattedMessage {...sellingPoints} values={{ li: (chunks) => <li>{chunks}</li> }} />
    </ul>
  );
};
